import {useChildContext} from "root/Contexts/ChildContext";
import React, {Fragment, useEffect, useState} from "react";
import {
    childBursary,
    childEAL, childEmployment,
    childFullTimeEducation, childHeader, childEETBursary,
    childPost16,
    childPPP, childReducedTimetable,
    childRiskOfExclusion,
    childSEN, childStarFunding,
    childStatutory,
    childTransitioning, formModes, childYear4Multiplication
} from "root/Base/HookFormComponents/childDataFormHelpers";
import {useForm} from "react-hook-form";

import HookSubFormChildDetails from "root/Base/HookFormComponents/HookSubFormChildDetails";
import HookFormGroupSend from "root/Base/HookFormComponents/SEND/HookFormGroupSend";
import HookFormGroupEducation from "root/Base/HookFormComponents/Education/HookFormGroupEducation";
import {SaveButton} from "root/Modals/SaveButton";
import {CancelButton} from "root/Modals/CancelButton";
import {newChildModes} from "root/NewToLAC/CreateChild3";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";

const Page2 = ( { notify, mode, initialChild }) =>
{
    const { child, isLoading, isPost16 } = useChildContext() ;
    const [ buttonsDisabled, setButtonsDisabled ] = useState ( false ) ;

    const SENDFormFields = {
        ... childEAL(child),
        ... childPPP(child),
        ... childSEN(child),
        ... childStatutory(child)
    }

    const EducationFormFields = {
        ... childPost16(child),
        ... childRiskOfExclusion(child),
        ... childTransitioning(child),
        ... childFullTimeEducation(child),
        ... childReducedTimetable(child),
        ... childStarFunding(child),
        ... childBursary(child),
        ... childEETBursary(child),
        ... childEmployment(child),
        ... childYear4Multiplication(child),
    }

    // If we are creating a child after a search, we may be passed an initial name
    const headerChild = initialChild === undefined ? child : initialChild ;

    const {register, control, reset, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                ... childHeader(headerChild),
                ...SENDFormFields,
                ...EducationFormFields
            }
        });

    useEffect(() =>
    {
        if ( isLoading === false )
        {
            const d = {
                ... childHeader(child),
                ...SENDFormFields,
                ...EducationFormFields
            }

            reset ( d, {
                shouldDirty: true
            } ) ;
        }
    }, [isLoading]);

    const onSubmit = (data) =>
    {
        notify( {
            fragment: data,
            stage: 3,
        });
    }

    const onClickSaveForm = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const onClickCancel = () =>
    {
        notify ( {stage: 1} );
    }

    const formMode = mode === newChildModes.NEW ? formModes.CREATE : formModes.EDIT ;

    const [ year_id ] = useWatchDropdown( {control, name: 'header.year_id' }) ;

    const isChildPost16 = () =>
    {
        let yearIsPost16 = false ;

        if ( year_id !== undefined && year_id !== null )
        {
            yearIsPost16 = [ 12,13 ].includes( year_id ) ;
        }
        else
        {
            yearIsPost16 = isPost16 ;
        }

        return yearIsPost16 ;
    }

    const acceptRow = () => {

        const controlProps = {
            control: control,
            register: register,
            watch: watch,
            formErrors: formErrors,
            readOnly: false
        }

        return (
            <form>

                <HookSubFormChildDetails key='childDetailForm' {...controlProps} search={false} formMode={formMode} sectionName='header' isPost16={isChildPost16()} />
                <HookFormGroupSend {...controlProps} formMode={formMode} isPost16={isChildPost16()}/>
                <HookFormGroupEducation{...controlProps} formMode={formMode} isPost16={isPost16} childYearGroup={1}/>

                <div className="button-row top-margin">
                    <SaveButton disabled={buttonsDisabled} onClick={onClickSaveForm} kay={'sb'}>Save and Continue</SaveButton>
                    <CancelButton disabled={buttonsDisabled} onClick={onClickCancel} key={'cb'}>Cancel</CancelButton>
                </div>
            </form>
        )
    }

    return (
        <Fragment>
            { ( isLoading === false || initialChild !== undefined ) && acceptRow()}
        </Fragment>

    )
}

export default Page2 ;